import React, { useEffect } from 'react';
import { Card, Col, Row, Tooltip } from 'antd';
import Meta from 'antd/es/card/Meta';
import { useMediaQuery } from '../../../hooks/MediaQuery.hook';
import { Link } from 'react-router-dom';
import { styles } from '../../../styles';
import { blogs } from '../../../utils/constant';

interface RelatedBlogProps {
    excludedId: number;
}

const RelatedBlog: React.FC<RelatedBlogProps> = ({ excludedId }) => {
    const relatedBlogs = blogs.filter(blog => blog.id !== excludedId);
    const spanSize = excludedId == -1 ? 20: 24;
    const innerSpanSize = excludedId == -1 ? 24: 8;
    const sliceLimit = excludedId == -1 ? 5: blogs.length;
    const matches = useMediaQuery('(min-width: 1000px)');

    useEffect(() => {
        window.scrollTo(0, 0);
      }, [excludedId]);

    return (
        <>
            <Row style={styles.flexDisplay}>
                <Col span={spanSize} style={{justifyContent: 'center', padding: '0px'}}>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        {relatedBlogs.reverse().slice(0, sliceLimit).map((blog: any, index: number)=>(
                            <Col key={index} span={matches ? innerSpanSize:24} style={{justifyContent: 'center', padding: '0px'}}>
                                <Link to={`/blogs/${blog?.url}-${blog?.id}`}>
                                    <Card
                                        hoverable
                                        style={{ marginBottom: '10px', background: 'rgba(19, 18, 18, 0.5)'}}
                                        cover={<img alt={blog?.title} src={blog?.image} />}
                                    >
                                        <Meta
                                        title={<Tooltip title={blog?.title}>
                                        <p style={{
                                                color: 'white',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'pre-wrap'
                                                }}>{blog?.title}</p>
                                        </Tooltip>} 
                                        />
                                    </Card>
                                </Link>
                        </Col>
                        ))}
                    </Row>                                          
                </Col>
            </Row>
        </>
    );
};

export default RelatedBlog;